import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import {
    SEARCH_QUERY,
    VALIDATE_ACCOUNT,
    ADD_ACCOUNT,
    CREATE_RULE,
    PROGRESS_INFO,
    VALIDATE_RULE,
    SET_VALIDRULE,
    SET_VALIDACCOUNT,
    RESET_POSTCONTAINER,
    QUERY_LIST,
    CHANGE_BULK_MODE,
    CHANGE_ACTIVE_TAB,
    CHANGE_VIEW_QUERY_MODE,
    EDIT_QUERY,
    SUPPORTED_LANGUAGES,
    TRANSLATE_TEXT,
    UPDATE_PROGRESS_INFO,
    JOIN_ACCOUNT,
    SET_COUNTRIES,
    SET_BOOLEAN,
    SET_PLATFORM,
    SET_ACCOUNT,
    SET_LOCATION,
    SET_ENTITY,
    SET_PUBLICATION,
    SET_PULL_COMMENTS,
    RESET_ACCOUNT_FORM,
    SET_ACCOUNT_LIST,
    SET_ACCOUNT_LIST_DATA,
    SET_BULK_INPUT_VALUE,
    FETCH_NEW_DATA,
    SET_SELECTED_TOPIC,
    SET_SELECTED_TOPIC_COLOR,
    SET_NEW_TOPIC,
    SET_NEW_TOPIC_COLOR,
    SET_SUB_TOPIC,
    SET_SUB_TOPIC_COLOR,
    RESET_EDIT_MODE,
    UPDATE_KEYWORD_TYPE,
    SHOW_SAMPLE_DATA,
    TOGGLE_KEYWORD_BLOCK,
    TOGGLE_ACCOUNT_BLOCK,
    TOGGLE_DATA__LOSS_ALERT,
    TOGGLE_SHOW_SAMPLE_BTN,
    SET_TIKTOK_KEYWORD,
    SET_TIKTOK_RULE_NAME,
    SET_POST_COUNTRY,
    SET_POST_URL,
    SET_POST_LIST_DATA,
    SET_VALID_COUNTRY,
    SET_VALID_ENTITY,
    SET_PLATFORM_QB,
} from "../actions/queryBuilderActions";

const queryBuilderReducer = (
    state = {
        queryResultsLoading: false,
        queryResults: [],
        isAccountValid: false,
        isAccountAdded: false,
        isRuleCreated: false,
        ruleCreatorLoading: false,
        platformWiseData: [],
        progressInfo: null,
        isQueryValid: false,
        createdQueryList: [],
        queryListLoading: false,
        bulkMode: false,
        activeTab: 0,
        viewQueryMode: true,
        queryForEdit: {},
        editMode: false,
        allSupportedLanguages: [],
        translatedTextInfo: [],
        verifyingAccount: false,
        addingAccount: false,
        joiningAccount: false,
        showSampleData: false,
        selectedCountryOptions: [
            // {
            //     flag: "sg",
            //     flag_miss: "no",
            //     label: "Singapore",
            //     value: "6cb66671-a789-11e4-a34f-74867a1157ba",
            //     short_name: "SG",
            // },
            {
                value: "4992ef7f-c70c-11e4-8659-22000aac892f",
                label: "Worldwide",
                flag: "worldwide",
                flag_miss: "yes",
                short_name: "Worldwide",
            },
        ],
        finalQuery: "",
        accountName: "",
        yTAccountURL: "",
        platformName: [],
        location: [],
        entityType: [],
        verifiedAccount: false,
        isPublication: false,
        fetchComment: false,
        fetchNewData: true,
        organiseExistingData: true,
        accountListData: [],
        accountList: [],
        bulkInputValue: "",
        selectedTopic: [],
        newTopicName: "",
        subTopicName: "",
        selectedTopicColor: "",
        newTopicColor: "",
        subTopicColor: "",
        keywords: [
            {
                keyword: "",
                enable: false,
                id: 0,
                translateOptionsList: [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }],
            },
        ],
        genericKeyword: [
            {
                keyword: "",
                enable: false,
                id: -1,
                translateOptionsList: [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }],
            },
        ],
        excludedKeyword: [
            {
                keyword: "",
                enable: false,
                id: -2,
                translateOptionsList: [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }],
            },
        ],
        expandKeywordBlock: false,
        expandAccountBlock: false,
        openDataLossAlert: false,
        showSampleButtonState: false,
        tiktokRuleName: "",
        tiktokKeyword: "",
        validTiktokKeyword: false,
        post_url: "",
        post_country: "",
        postListData: [],
        invalidAccounts: [],
        validAccounts: [],
        validCountry: null,
        validEntity: null,
        platform: null,
    },
    action,
) => {
    switch (action.type) {
        case isPending(SEARCH_QUERY):
            return (state = {
                ...state,
                queryResultsLoading: true,
                queryResults: [],
            });
        case isRejected(SEARCH_QUERY):
            return (state = {
                ...state,
                queryResultsLoading: false,
                queryResults: [],
            });
        case isFulfilled(SEARCH_QUERY):
            return (state = {
                ...state,
                queryResultsLoading: false,
                queryResults: action.payload.hits,
                platformWiseData: action.payload?.aggregations?.conversation_over_time_platform?.buckets || [],
            });
        case isPending(VALIDATE_ACCOUNT):
            return (state = {
                ...state,
                verifyingAccount: true,
                invalidAccounts: [],
                validAccounts: [],
            });
        case isRejected(VALIDATE_ACCOUNT):
            return (state = {
                ...state,
                verifyingAccount: false,
            });
        case isFulfilled(VALIDATE_ACCOUNT):
            console.log("VALIDATE_ACCOUNT", action.payload);
            if (action.payload.status) {
                return (state = {
                    ...state,
                    isAccountValid: true,
                    verifyingAccount: false,
                    invalidAccounts: [],
                    validAccounts: action.payload.records,
                });
            } else {
                return (state = {
                    ...state,
                    isAccountValid: false,
                    verifyingAccount: false,
                    invalidAccounts: action.payload,
                });
            }
        case isPending(ADD_ACCOUNT):
            return (state = {
                ...state,
                addingAccount: true,
            });
        case isRejected(ADD_ACCOUNT):
            return (state = {
                ...state,
                addingAccount: false,
            });
        case isFulfilled(ADD_ACCOUNT):
            if (action.payload.status) {
                return (state = {
                    ...state,
                    isAccountAdded: true,
                    addingAccount: false,
                });
            } else {
                return (state = {
                    ...state,
                    isAccountAdded: false,
                    addingAccount: false,
                });
            }
        case isPending(CREATE_RULE):
            return (state = {
                ...state,
                isRuleCreated: false,
                ruleCreatorLoading: true,
            });
        case isRejected(CREATE_RULE):
            return (state = {
                ...state,
                isRuleCreated: false,
                ruleCreatorLoading: false,
            });
        case isFulfilled(CREATE_RULE):
            return (state = {
                ...state,
                isRuleCreated: true,
                ruleCreatorLoading: false,
            });
        case isFulfilled(PROGRESS_INFO):
            return (state = {
                ...state,
                progressInfo: action.payload.data.queryBuilderProgress,
            });

        case isRejected(VALIDATE_RULE):
            return (state = {
                ...state,
                isQueryValid: false,
            });
        case isFulfilled(VALIDATE_RULE):
            return (state = {
                ...state,
                isQueryValid: action?.payload?.data?.is_valid || false,
            });
        case isPending(QUERY_LIST):
            return (state = {
                ...state,
                createdQueryList: [],
                queryListLoading: true,
            });
        case isRejected(QUERY_LIST):
            return (state = {
                ...state,
                createdQueryList: [],
                queryListLoading: false,
            });
        case isFulfilled(QUERY_LIST):
            return (state = {
                ...state,
                createdQueryList: action.payload.data.filters.topicsAndSubtopics,
                queryListLoading: false,
            });

        case SET_VALIDRULE:
            return (state = {
                ...state,
                isQueryValid: action.payload,
            });
        case SET_VALIDACCOUNT:
            return (state = {
                ...state,
                isAccountValid: action.payload,
            });
        case RESET_POSTCONTAINER:
            return (state = {
                ...state,
                queryResults: action.payload,
            });
        case CHANGE_BULK_MODE:
            return (state = {
                ...state,
                bulkMode: action.payload,
                invalidAccounts: [],
            });
        case CHANGE_ACTIVE_TAB:
            return (state = {
                ...state,
                activeTab: action.payload,
            });
        case CHANGE_VIEW_QUERY_MODE:
            return (state = {
                ...state,
                viewQueryMode: action.payload,
            });
        case EDIT_QUERY:
            return (state = {
                ...state,
                queryForEdit: action.payload,
            });
        case isFulfilled(SUPPORTED_LANGUAGES):
            return (state = {
                ...state,
                allSupportedLanguages: action.payload.data.languages,
            });
        case isFulfilled(TRANSLATE_TEXT):
            return (state = {
                ...state,
                translatedTextInfo: action.payload.data,
            });
        case isFulfilled(UPDATE_PROGRESS_INFO):
            return (state = {
                ...state,
            });
        case isPending(JOIN_ACCOUNT):
            return (state = {
                ...state,
                joiningAccount: true,
            });
        case isRejected(JOIN_ACCOUNT):
            return (state = {
                ...state,
                joiningAccount: false,
            });
        case isFulfilled(JOIN_ACCOUNT):
            return (state = {
                ...state,
                joiningAccount: false,
            });
        case SET_COUNTRIES:
            return (state = {
                ...state,
                selectedCountryOptions: action.payload,
            });
        case SET_VALID_COUNTRY:
            return (state = {
                ...state,
                validCountry: action.payload,
            });
        case SET_VALID_ENTITY:
            return (state = {
                ...state,
                validEntity: action.payload,
            });
        case SET_BOOLEAN:
            return (state = {
                ...state,
                finalQuery: action.payload,
            });
        case SET_PLATFORM:
            return (state = {
                ...state,
                platformName: action.payload,
            });
        case SET_ACCOUNT:
            return (state = {
                ...state,
                accountName: action.payload,
            });
        case "SET_ACCOUNT_URL":
            return (state = {
                ...state,
                yTAccountURL: action.payload,
            });
        case SET_POST_COUNTRY:
            return (state = {
                ...state,
                post_country: action.payload,
            });
        case SET_PLATFORM_QB:
            return (state = {
                ...state,
                platform: action.payload,
            });
        case SET_POST_URL:
            return (state = {
                ...state,
                post_url: action.payload,
            });
        case SET_LOCATION:
            return (state = {
                ...state,
                location: action.payload,
            });
        case SET_ENTITY:
            return (state = {
                ...state,
                entityType: action.payload,
            });
        case SET_TIKTOK_RULE_NAME:
            return (state = {
                ...state,
                tiktokRuleName: action.payload,
            });
        case SET_TIKTOK_KEYWORD:
            return (state = {
                ...state,
                tiktokKeyword: action.payload.value,
                validTiktokKeyword: action.payload.isValid,
            });
        case SET_PUBLICATION:
            return (state = {
                ...state,
                isPublication: !state.isPublication,
            });
        case SET_PULL_COMMENTS:
            return (state = {
                ...state,
                fetchComment: !state.fetchComment,
            });
        case RESET_ACCOUNT_FORM:
            return (state = {
                ...state,
                platformName: [],
                accountName: "",
                location: [],
                entityType: [],
                isPublication: false,
                fetchComment: false,
                post_url: "",
                post_country: "",
                yTAccountURL: "",
                // tiktokKeyword: "",
            });
        case SET_ACCOUNT_LIST:
            return (state = {
                ...state,
                accountList: action.payload,
            });
        case SET_ACCOUNT_LIST_DATA:
            return (state = {
                ...state,
                accountListData: action.payload,
            });
        case SET_POST_LIST_DATA:
            return (state = {
                ...state,
                postListData: action.payload,
            });

        case SET_BULK_INPUT_VALUE:
            return (state = {
                ...state,
                bulkInputValue: action.payload,
                invalidAccounts: [],
            });
        case FETCH_NEW_DATA:
            return (state = {
                ...state,
                fetchNewData: action.payload,
            });

        case SET_SELECTED_TOPIC:
            return (state = {
                ...state,
                selectedTopic: action.payload,
            });
        case SET_SELECTED_TOPIC_COLOR:
            return (state = {
                ...state,
                selectedTopicColor: action.payload,
            });
        case SET_NEW_TOPIC:
            return (state = {
                ...state,
                newTopicName: action.payload,
            });
        case SET_NEW_TOPIC_COLOR:
            return (state = {
                ...state,
                newTopicColor: action.payload,
            });
        case SET_SUB_TOPIC:
            return (state = {
                ...state,
                subTopicName: action.payload,
            });
        case SET_SUB_TOPIC_COLOR:
            return (state = {
                ...state,
                subTopicColor: action.payload,
            });
        case UPDATE_KEYWORD_TYPE:
            return (state = {
                ...state,
                [action.keywordType]: action.payload,
            });
        case RESET_EDIT_MODE:
            return (state = {
                ...state,
                finalQuery: "",
                accountName: "",
                platformName: [],
                location: [],
                entityType: [],
                verifiedAccount: false,
                isPublication: false,
                fetchComment: false,
                fetchNewData: true,
                accountListData: [],
                postListData: [],
                accountList: [],
                bulkInputValue: "",
                selectedTopic: [],
                newTopicName: "",
                subTopicName: "",
                selectedTopicColor: "",
                newTopicColor: "",
                subTopicColor: "",
                keywords: [
                    {
                        keyword: "",
                        enable: false,
                        translateOptionsList: [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }],
                    },
                ],
                genericKeyword: [
                    {
                        keyword: "",
                        enable: false,
                        translateOptionsList: [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }],
                    },
                ],
                excludedKeyword: [
                    {
                        keyword: "",
                        enable: false,
                        translateOptionsList: [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }],
                    },
                ],
                expandKeywordBlock: false,
                expandAccountBlock: false,
                tiktokKeyword: "",
                queryResultsLoading: false,
                showSampleData: false,
                queryResults: [],
            });
        case SHOW_SAMPLE_DATA:
            return (state = {
                ...state,
                showSampleData: action.payload,
            });
        case TOGGLE_KEYWORD_BLOCK:
            return (state = {
                ...state,
                expandKeywordBlock: action.payload,
            });
        case TOGGLE_ACCOUNT_BLOCK:
            return (state = {
                ...state,
                expandAccountBlock: action.payload,
            });
        case TOGGLE_DATA__LOSS_ALERT:
            return (state = {
                ...state,
                openDataLossAlert: !state.openDataLossAlert,
            });
        case TOGGLE_SHOW_SAMPLE_BTN:
            return (state = {
                ...state,
                showSampleButtonState: !state.showSampleButtonState,
            });
        default:
            return state;
    }
};

export default queryBuilderReducer;
